<template>
  <div
  v-if="post"
  class="type"
  :class="[post.type]"
  :data-slug="post.slug">

    <section class="component login bg-gray-light">

      <div class="component-inner">
        <!-- <div class="flex flex-col lg:flex-row gap-8 xl:gap-20 2xl:gap-32 w-full max-w-screen-2xl mx-auto py-20 pt-40 xl:pt-40 z-10"> -->
          <header class="block-header">
            <h1>{{ post.title }}</h1>
            <div class="lead regular" v-html="post.excerpt.excerpt" />
          </header>

          <form class="login-form" v-on:submit.prevent="validateBeforeSubmit">
            <div class="form-group text-left mb-5">
              <label class="custom-label control-label hidden">Brukernavn</label>
              <input class="form-control w-full p-4 bg-white " type="text" name="username" placeholder="Brukernavn" v-model.trim="username">
            </div>

            <div class="form-group text-left mb-5">
              <label class="custom-label control-label hidden">Password</label>
              <input class="form-control password-field w-full p-4 bg-white " type="password" name="password" placeholder="Passord" v-model.trim="password">
            </div>

            <div class="text-red-400" v-if="errorMessage">
              <p>{{ errorMessage }}</p>
            </div>

            <div class="links">
              <button class="button green text-green-dark " type="submit">Logg inn</button>
              <a class="forgot-password" :href="`${baseURL}/wp-login.php?action=lostpassword`">Glemt passord</a>
              <!-- <router-link class="forgot-password" :to="'/glemt-passord'">Glemt passord?</router-link> -->
            </div>


          </form>



        <!-- </div> -->

      </div>

    </section>

  </div>
</template>

<script>
import postMeta from '@/mixins/postMeta.js';

export default {
  components: {},

  data : () => ({
    errors: [],
    error: Boolean = false,
    errorMessage: null,
    observer: null,
    password: null,
    username: null,
    baseURL: process.env.MIX_API_BASE_URL,
  }),

  mixins: [
    postMeta,
  ],

  computed: {
    post() {
      const post = this.$store.getters.getPageBySlug("innlogging");

      if (post) {
        return {
          id: post.id,
          type: post.type,
          slug: post.slug,
          title: post.title.rendered,
          excerpt: post.acf.excerpt,
          media: post.featured_media,
          template: post.template ? post.template : 'default',
          head: post.yoast_head_json,
        }
      }
      return false
    }
  },

  methods: {

    resetData() {},

    validateBeforeSubmit () {
      if (this.username.length && this.password.length) {
        // console.log(this.username, this.password);

        this.$store.dispatch('login', { username: this.username, password: this.password }).then(result => {
          // console.log('login result', result);

          if (result.success) {
            // this.$router.push('/kompasset');
            this.$router.push({ name: 'ResourceMain'});
          } else {
            this.errorMessage = result.message;
          }
        })
      }

    },
  },

  mounted() {
    this.$store.dispatch("updateHero", false);
  },

  watch: {
    $route: {
      immediate: true,
      handler: function(newVal, oldVal) {
        this.isModalVisible = newVal.meta && newVal.meta.isModalVisible;
      }
    },
  }
}
</script>
